import React from "react";
import { useSelector } from "react-redux";

import { Glyphicon } from "../Glyphicon/Glyphicon";
import SvgComponent from "../SvgComponent/SvgComponent";

import {
  Container,
  Column,
  DataContainer,
  HeaderColumn,
  Title,
  SubTitle,
  RoofTitle,
  Table,
  Header,
  CardsContainer,
  Card,
  CardTitle,
  RoofThumbnail,
  USPContainer,
} from "./style";

export const RoofCompare = () => {
  const init = useSelector((state) => state.init);
  const { assetBaseUrl, alias } = init;

  const tinRoofThumbnail = `${assetBaseUrl}/store/uterumsguide2016/roof/ROOF_TIN.png`;
  const isolatedRoofThumbnail = `${assetBaseUrl}/store/uterumsguide2016/roof/ROOF_SANDWICH_SILVER.png`;
  const roofThumbnail = `${assetBaseUrl}//store/uterumsguide2016/roof/ROOF_20.png`;
  const tinRoofs = [
    {
      name: alias.bfcTinRoof,
      value: "OPTIMAL",
      iconName: "summer",
      uValueRoof: "n.a",
      color: alias.bfcTinRoofColors,
    },
  ];

  const isolatedRoofs = [
    {
      name: alias.bfcSandwichRoof,
      value: "ISOMAX",
      iconName: "winter",
      uValueRoof: alias.bfcIsolatedWinterUValueRoof,
      color: alias.bfcSandwichRoofColors,
    },
  ];

  const roofs = [
    {
      name: alias.bfcKanalplast10mm,
      value: "OPTIMAL",
      iconName: "summer",
      uValueRoof: alias.bfcSummerUValueRoof,
      color: alias.bfcColorOpalvit,
      lightTransmission: "57%",
      layers: 4,
    },
    {
      name: alias.bfcKanalplast32mm,
      value: "ISOLENT",
      iconName: "fall",
      uValueRoof: alias.bfcSpringFallUValueRoof,
      color: alias.bfcColorOpalvit,
      lightTransmission: "44%",
      layers: 10,
    },
    {
      name: alias.bfcKanalplast32mmComfort,
      value: "ISOLENT",
      iconName: "fall",
      uValueRoof: alias.bfcSpringFallUValueRoof,
      comfort: true,
      color: alias.bfcColorOpalvit,
      lightTransmission: "38%",
      layers: 10,
    },
    {
      name: alias.bfcKanalplast50mm,
      value: "ISOMAX",
      iconName: "winter",
      uValueRoof: alias.bfcWinterUValueGlass,
      color: alias.bfcColorOpalvit,
      lightTransmission: "40%",
      layers: 10,
    },
  ];

  return (
    <>
      <Header>{alias.bfcRoofOption}</Header>
      <Container>
        <HeaderColumn>
          <DataContainer></DataContainer>
          <DataContainer>
            <Title>{alias.bfcSeason}</Title>
          </DataContainer>
          <DataContainer>
            <Title>{alias.bfcUValue}</Title>
            <SubTitle>{alias.bfcUValueDescription}</SubTitle>
          </DataContainer>
          <DataContainer>
            <Title>{alias.bfcComfort}</Title>
            <SubTitle>{alias.bfcComfortDescription}</SubTitle>
          </DataContainer>
          <DataContainer>
            <Title>{alias.bfcColor}</Title>
          </DataContainer>
          <DataContainer>
            <Title>{alias.bfcLightTransmission}</Title>
          </DataContainer>
          <DataContainer>
            <Title>{alias.bfcSeasonLayers}</Title>
          </DataContainer>
        </HeaderColumn>
        <Table>
          {roofs.map((roof) => (
            <Column key={roof.name} color="#1788c6">
              <DataContainer>
                <RoofTitle color="#1788c6">{roof.name}</RoofTitle>
              </DataContainer>
              <DataContainer>
                <SvgComponent name={roof.iconName} />
              </DataContainer>
              <DataContainer>{roof.uValueRoof}</DataContainer>
              <DataContainer>{roof.comfort && "X"}</DataContainer>
              <DataContainer>{roof.color}</DataContainer>
              <DataContainer>{roof.lightTransmission}</DataContainer>
              <DataContainer>{roof.layers}</DataContainer>
            </Column>
          ))}
        </Table>

        <Table>
          {tinRoofs.map((roof) => (
            <Column key={roof.name} color="#d1836b">
              <DataContainer>
                <RoofTitle color="#d1836b">{roof.name}</RoofTitle>
              </DataContainer>
              <DataContainer>
                <SvgComponent name={roof.iconName} />
              </DataContainer>
              <DataContainer>{roof.uValueRoof}</DataContainer>
              <DataContainer>{roof.comfort && "X"}</DataContainer>
              <DataContainer>{roof.color}</DataContainer>
              <DataContainer>{roof.lightTransmission}</DataContainer>
              <DataContainer>{roof.layers}</DataContainer>
            </Column>
          ))}
        </Table>

        {/* SandwhichRoofs are not available on Nordrum channels (i.e. 7 and 8) */}
        {init.channelId !== "7" &&
          init.channelId !== "8" &&
          isolatedRoofs &&
          isolatedRoofs.length && (
            <>
              <Table>
                {isolatedRoofs.map((roof) => (
                  <Column key={roof.name} color="#a74d39">
                    <DataContainer>
                      <RoofTitle color="#a74d39">{roof.name}</RoofTitle>
                    </DataContainer>
                    <DataContainer>
                      <SvgComponent name={roof.iconName} />
                    </DataContainer>
                    <DataContainer>{roof.uValueRoof}</DataContainer>
                    <DataContainer>{roof.comfort && "X"}</DataContainer>
                    <DataContainer>{roof.color}</DataContainer>
                    <DataContainer>{roof.lightTransmission}</DataContainer>
                    <DataContainer>{roof.layers}</DataContainer>
                  </Column>
                ))}
              </Table>
            </>
          )}
      </Container>
      <CardsContainer>
        <Card color="#1788c6">
          <CardTitle color="#1788c6">{alias.bfcKanalplastRoof}</CardTitle>
          <RoofThumbnail src={roofThumbnail} />
          <USPContainer color="#1788c6">
            <Glyphicon name="ok-2" />
            <span>{alias.bfcKanalplastUSP1}</span>
          </USPContainer>
          <USPContainer color="#1788c6">
            <Glyphicon name="ok-2" />
            <span>{alias.bfcKanalplastUSP2}</span>
          </USPContainer>
          <USPContainer color="#1788c6">
            <Glyphicon name="ok-2" />
            <span>{alias.bfcKanalplastUSP3}</span>
          </USPContainer>
          <USPContainer color="#1788c6">
            <Glyphicon name="ok-2" />
            <span>{alias.bfcKanalplastUSP4}</span>
          </USPContainer>
        </Card>
        <Card color="#d1836b">
          <CardTitle color="#d1836b">{alias.bfcTinRoof}</CardTitle>
          <RoofThumbnail src={tinRoofThumbnail} />
          <USPContainer color="#d1836b">
            <Glyphicon name="ok-2" />
            <span>{alias.bfcTinRoofUSP1}</span>
          </USPContainer>
          <USPContainer color="#d1836b">
            <Glyphicon name="ok-2" />
            <span>{alias.bfcTinRoofUSP2}</span>
          </USPContainer>
          <USPContainer color="#d1836b">
            <Glyphicon name="ok-2" />
            <span>{alias.bfcTinRoofUSP3}</span>
          </USPContainer>
          <USPContainer color="#d1836b">
            <Glyphicon name="ok-2" />
            <span>{alias.bfcTinRoofUSP4}</span>
          </USPContainer>
        </Card>

        {/* SandwhichRoofs are not available on Nordrum channels (i.e. 7 and 8) */}
        {init.channelId !== "7" &&
          init.channelId !== "8" &&
          isolatedRoofs &&
          isolatedRoofs.length && (
            <>
              <Card color="#a74d39">
                <CardTitle color="#a74d39">{alias.bfcSandwichRoof}</CardTitle>
                <RoofThumbnail src={isolatedRoofThumbnail} />
                <USPContainer color="#a74d39">
                  <Glyphicon name="ok-2" />
                  <span>{alias.bfcSandwichRoofUSP1}</span>
                </USPContainer>
                <USPContainer color="#a74d39">
                  <Glyphicon name="ok-2" />
                  <span>{alias.bfcSandwichRoofUSP2}</span>
                </USPContainer>
                <USPContainer color="#a74d39">
                  <Glyphicon name="ok-2" />
                  <span>{alias.bfcSandwichRoofUSP3}</span>
                </USPContainer>
                <USPContainer color="#a74d39">
                  <Glyphicon name="ok-2" />
                  <span>{alias.bfcSandwichRoofUSP4}</span>
                </USPContainer>
              </Card>
            </>
          )}
      </CardsContainer>
    </>
  );
};

export default RoofCompare;
